export default "__VITE_ASSET__Cu8j$Al1__"